<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202310_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202310_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>ひと夏で5歳老ける！？</span><br>夏に受けた紫外線は<br>アフターケアが最重要</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">ひと夏で5歳、年をとる！？<br>紫外線のダメージを受けた肌。<br>大切な「洗顔ケア」見逃さないで</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202310_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線はアフターケアが重要</h3>
        <p class="mb-3">毎年気になるのが夏の紫外線。</p>
        <p class="mb-3">夏に受けた紫外線諦めていませんか？</p>
        <p class="mb-3">紫外線はアフターケアがとても大切なことをご存知でしょうか？</p>
        <p class="mb-3">「ひと夏で5歳、老けるなら。。」</p>
        <p class="mb-3">美白や美肌を目指す人だけでなくとも、ヒヤッしますね。</p>
        <p class="mb-3">その背景には、夏の強い紫外線による</p>
        <p class="mb-3">「肌の保湿機能が低下」<br>「シミ予備軍を生成」<br>「肌の弾力減少によりシワが深まる」</p>
        <p class="mb-3">など、一年の中でも最も肌へのダメージが大きいから。</p>
        <p class="mb-3">紫外線は一年中降り注いでおり、ブロックケアもアフターケアも、油断していると、肌トラブルを引き起こす原因となります。</p>
        <p>それでは、夏の終わりのこの時期。どういった対策や肌ケアをすればよいのか。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5 mb-3">みんなは紫外線のアフターケア、どうしてる？</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">では、まずは「紫外線を受けた後の肌ケア」に対して皆さんがどう思っているのか？</p>
      <p>その現状を探るべく、30～50代女性を対象に「紫外線を受けた後の肌ケア」に関する調査を実施しました。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">夏の日差しは女性の天敵！<br>紫外線対策をしていたという人は78％</h3>
        <p class="mb-3">「夏の紫外線対策をしていますか？」と質問したところ、およそ8割の方が<strong>『はい』</strong>と回答。</p>
        <p class="mb-3">また「夏に紫外線対策をしないで外出することに不安はありますか？」の質問に</p>
        <p class="mb-3"><strong>『強い不安がある（52.0%）』</strong><br>と回答した方が最も多く、次いで</p>
        <p class="mb-3"><strong>『ある程度不安がある（44.6%）』<br>『不安はない（3.4%）』</strong>と続きました。</p>
        <p class="mb-3">ほとんどの女性が、夏に紫外線対策をせずに外出することに不安を感じていると言えるでしょう。</p>
        <p>紫外線ダメージを受けないように対策することは、肌にとってとても重要なことですね。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">紫外線予防の第1位は<br>【こまめな日焼け止め】<br>具体的な方法は？</h3>
        <p class="mb-3">「どのような紫外線予防を行っていますか？」と質問してみました。</p>
        <p class="mb-3"><strong>『こまめな日焼け止めの使用（80.5%）』<br>『日傘や長袖を着るなど紫外線の物理的遮断（67.9%）』<br>『その他の紫外線予防グッズの活用（26.6%）』<br>『インナーケア（7.2%）』<br>『飲む日焼け止めの服用（5.6%）』</strong></p>
        <p class="mb-3">日焼け止めや長袖の着用など、さまざまな方法で紫外線予防に余念がないことがわかりますが、実際には、紫外線予防をしていたにもかかわらずダメージを感じた経験がある方もいるのではないでしょうか。</p>
        <p>「紫外線予防を行なっていたにもかかわらず、紫外線ダメージを受けてしまったと感じたことはありますか？」と質問したところ、約85％の方が<strong>『ある』</strong>と回答しました。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">具体的にどのような紫外線イメージを感じた？</h3>
        <p class="mb-3">紫外線予防をしっかり行っていても、肌ダメージを感じた経験がある方は多いことがわかりました。</p>
        <p class="mb-3">では「紫外線により生じた肌悩みを教えてください」と質問したところ、</p>
        <p class="mb-3"><strong>『シミ、そばかすができる（53.0%）』</strong></p>
        <p class="mb-3">と回答した方が最も多く、次いで</p>
        <p class="mb-3"><strong>『色が黒くなる（42.4%）』<br>『ヒリつくような炎症が起きる、火傷する（30.9%）』<br>『しわ、たるみといった肌の加齢加速（23.3%）』<br>『色素沈着（21.8%）』<br>『肌の痒み（18.5%）』</strong></p>
        <p>紫外線は、シミや炎症、たるみなど、見た目年齢に直結するようなさまざまな肌ダメージを与えることがわかりました。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_05.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">紫外線のダメージケアとして洗顔を重視しない人は多い！<br>最も多い理由は【肌への刺激】</h3>
        <p class="mb-3">紫外線予防をしっかりしていても、肌ダメージを感じたことがある方が多いよう。</p>
        <p class="mb-3">では、紫外線ダメージ後の肌ケア方法を伺いました。</p>
        <p class="mb-3">「受けてしまった紫外線ダメージに対して、特に力を入れるのはどのようなケアですか？」の質問に</p>
        <p class="mb-3"><strong>『化粧水、乳液など普段の基礎ケアを丁寧に行う（42.5%）』</strong></p>
        <p class="mb-3">と回答した方が最も多く、次いで</p>
        <p><strong>『鎮静効果のある化粧水や美容液によるケア（27.2%）』<br>
        『冷やす、引き締めジェルなどの冷却ケア（25.8%）』<br>
        『乳液やクリームによる保湿ケア（24.7%）』<br>
        『特に何もしない（23.2%）』<br>
        『洗顔（14.5%）』</strong></p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <p class="mb-3">紫外線ダメージを受けた後には、肌への水分補給や保湿などのケアに力を入れている方が多いようです。</p>
        <p class="mb-3">一方、<strong>洗顔を重視している方はおよそ15％に留まるという結果</strong>が出ています。</p>
        <p class="mb-3">そこで、「紫外線ダメージに対するケアとして洗顔に力を入れない理由は何ですか？」と質問したところ、</p>
        <p class="mb-3"><strong>『肌に刺激を与えすぎる可能性があるため（39.0%）』<br>
        『面倒くさい（27.1%）』<br>
        『必要性を感じない（22.5%）』<br>
        『乾燥を引き起こす可能性がある（20.7%）』</strong></p>
        <p class="mb-3">と続きおよそ4割の方が、肌に刺激を与えすぎる可能性があるため洗顔に力を入れないと回答しています。</p>
        <p class="mb-3">紫外線ダメージを受けた肌には、洗顔時の摩擦が肌の刺激になると考える方が多いのかもしれません。</p>
        <p>また、「必要性を感じない」という声もあり、紫外線ダメージに対する洗顔の効果に期待している方が少ないことも明らかになりました。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_07.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202310_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">スキンケア用品の効果が高まるような洗顔なら使ってみたい女性が約8割！</h3>
        <p class="mb-3">紫外線のダメージケアとして洗顔を重視しない方が多いことが明らかになりました。</p>
        <p class="mb-3">そこで、今使っているスキンケア用品の効果が高まるような洗顔を使ってみたいか伺いました。</p>
        <p class="mb-3">「今使っているスキンケア用品の効果が高まるような洗顔を使ってみたいと思いますか？」と質問したところ、およそ85％の方が<strong>『思う』</strong>と回答しました。</p>
        <p class="mb-3">洗顔後に行うスキンケアの効果が高まるなら、洗顔にも注目したいと思う女性は多いようです。</p>
        <p class="mb-3"><strong>しっかりと汚れを落とすことで、化粧品や美容液がより浸透しやすくなり</strong></p>
        <p><strong>紫外線による肌ダメージを防ぐ効果が期待できるのではないでしょうか。</strong></p>
      </div>
    </div>

    <div class="layer_03  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_03.jpg">
      <div class="layer-text">
        <p class="mb-3">今回の調査で、30～50代女性の夏の紫外線ダメージ肌のケア方法が明らかになりました。</p>
        <p class="mb-3">紫外線を受けた後のダメージ肌は、化粧水や乳液等で丁寧にケアすると回答した方が多い一方、スキンケア前に必要な洗顔はあまり重視してないことがわかりました。</p>
        <p class="mb-3">一方で、スキンケア効果が高まるような洗顔を使ってみたいという意見も多く、高いスキンケア効果を期待する女性が多いことがわかりました。</p>
        <p>せっかくスキンケアを行うなら、洗顔から丁寧に行って、紫外線ダメージを受けた肌をいたわりたいものですね。</p>
      </div>
    </div>

    <h2 class="mb-5 pt-5">夏の紫外線ダメージを<br>持ち越さないために。<br>丁寧な洗顔と保湿はマスト。<br>素肌がほっとするスキンケアを。</h2>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202310_09.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left">BASIC</h2>
        </div>
      </div>
    </div>

    <h2 class="mt-5 pt-5">自分の素肌に、素直に向き合える<br>ベーシックシリーズ</h2>

    <div class="mb-5 pb-5">
      <p class="mb-3">ベーシックケアの製品名<br>すべてに付けられた「薬用」。</p>
      <p class="mb-5">これは有効成分を一定濃度配合している<br>「医薬部外品」として<br>認められたということを表しています。</p>
      <p class="mb-3">毎日つづける基本のステップにこそ、手応えを感じてほしい。</p>
      <p class="mb-5">そんな願いから生まれたアイテムです。</p>
      <p class="mb-3">また、一般的にはスペシャルアイテムとされるパックを<br>ベーシックケアに取り入れているのも</p>
      <p>毎日のお手入れの大切さへこだわる、マナビス化粧品ならではです。</p>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3"><small>知ってほしいのはこの3つ</small></p>
        <p class="mb-3 fs-2">「朝晩の洗顔」「上質泡」「保湿」</p>
        <p class="mb-5">簡単だけど丁寧なルーティンケアの積み重ね。</p>
        <p class="mb-3">朝と夜の「洗顔」タイムで</p>
        <p class="mb-3">素肌をもっちり「上質な泡」で優しく包み込み</p>
        <p class="mb-5">無垢で清潔な状態のお肌をしっかりと「保湿」する。</p>
        <p>女性も男性も年齢に関係なく<br>毎日できる大切なスキンケアは「洗顔」と「保湿」です。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5 mb-3">ずっと素肌でいたいから。</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">基本の日々のケアに立ち返り、明日も自分の肌を好きでいるために。</p>
      <p>あなたらしい毎日をあなたのペースで取り入れてみてほしい。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュ<br>チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">グリチルリチン酸ジカリウム配合。</p>
        <p class="mb-3">毎朝晩の洗顔に。</p>
        <p class="mb-3">うるおいはそのままに、やわらかな泡で包むように洗う。</p>
        <p>16種類の植物由来成分配合のアミノ酸系弱酸性ジェル状せっけん。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwash_tube_202310.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_tube_202310.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンマスク<br>チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">インバスケアで保湿革命。</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状のテクスチャーでお風呂でも使えるアイテムです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュ チューブタイプ ＋ マナビスバブルフォーマー（泡立て器）2点セット</h3>
        <p class="mb-3">¥6,000</p>
        <p class="mb-3">薬用スキンウォッシュ チューブタイプと、</p>
        <p class="mb-3">洗顔料の泡立ちを良くし、よりきめの細かい弾力のある泡を作ってくれる</p>
        <p>「マナビスバブルフォーマー（泡立て器）」の待望の2点セットが登場。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwash_set_202310.jpg">
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000003.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000003.000124389.html">紫外線ダメージを受けた肌ケア方法として洗顔はあまり重視されていない？！その理由とは？</a></p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000004.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000004.000124389.html">美容皮膚科医の約95％が洗顔はスキンケアにおいて重要と回答！正しい洗顔方法や洗顔料の選び方とは？</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p class="mb-3">一般の方へのアンケート*1<br>
        調査概要：「紫外線を受けた後の肌ケアに関する実態調査」<br>
        【調査期間】2023年9月4日（月）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】1,011人<br>
        【調査対象】調査回答時に30代～50代女性であると回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ</p>
        <p>美容皮膚科医の方へのアンケート*2<br>
        【調査概要】：「洗顔の実態」に関する調査<br>
        【調査期間】：2023/09/8（金）～2023/09/9（土）<br>
        【調査方法】：リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】：20代～60代の女性：515人／美容皮膚科医：508人<br>
        【調査対象】：20代～60代の女性／美容皮膚科医<br>
        【モニター提供元】：ゼネラルリサーチ<br>
        ※この調査の内容は、あくまで美容皮膚科医の方を対象にしたアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_03 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_03.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img,.layer_03 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text,.layer_03 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  left: 25px;
  bottom: 20px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}
.layer_02 {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/column/202310_09.jpg');
  background-size: cover;
  min-height: 640px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 60px; /* テキストと画像の端の間に余白を設定 */
  background-position: center;
}
.layer_02 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_02 .layer-text .layer-text-inner h2 {
  font-size: 3em;
  color: #7e7e74;
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_02 {
    min-height: 300px;
    padding: 15px;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>